import {Component} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

import {tap} from 'rxjs';
import {ReportActionsService} from 'src/app/services/accountant/report-actions.service';
import {Utils} from '../../utils/utils';
import {ToastrService} from 'ngx-toastr';

/**
 * This component allows the user to download data from the server
 */
@UntilDestroy()
@Component({
  selector: 'app-salary-generate-reports',
  templateUrl: './salary-generate-reports.component.html',
  styleUrls: ['./salary-generate-reports.component.scss'],
})
export class SalaryGenerateReportsComponent {
  /**
   * Variable hide/show text messages
   */
  public visibilityText = false;

  constructor(
    private dataReportsService: ReportActionsService,
    private notifier: ToastrService
  ) {}

  generateAllReports() {
    this.dataReportsService
      .generateAllReports()
      .pipe(
        untilDestroyed(this),
        tap(() => (this.visibilityText = true))
      )
      .subscribe(response => {
        Utils.downloadBlobFile(response, 'report.7z');
      });
  }

  sendReports() {
    this.notifier.info('The feature is in progress');
  }
}
